import { gql } from '@apollo/client';

export const CREATE_COMPONENTS_LIST = gql`
    mutation createComponentList( $input: CreateComponentListInput! ) {
        result: createComponentList( input: $input ) {
            componentListId
            type
            uuids
        }
    }
`;